import { render, staticRenderFns } from "./PorFiscal.vue?vue&type=template&id=490c443e&scoped=true&lang=pug&"
import script from "./PorFiscal.vue?vue&type=script&lang=js&"
export * from "./PorFiscal.vue?vue&type=script&lang=js&"
import style0 from "./PorFiscal.vue?vue&type=style&index=0&id=490c443e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490c443e",
  null
  
)

export default component.exports